module.exports = __webpack_public_path__ + "img/337.036312e4.jpg";